package com.devi3east.bashbuddy.auth.responses

import com.devi3east.bashbuddy.account.profile.domain.models.Profile
import kotlinx.serialization.Serializable

@Serializable
data class AuthResponse(
    val accessToken: String,
    val refreshToken: String,
    val expiresIn: Long,
    val tokenType: String,
    val profile: Profile
)